import React from 'react';

export function ShopifyCart({ isOpen, onClose, cart }) {
    const lines = cart?.lines?.edges?.map((e) => e.node) || [];
    const totalAmount = cart?.cost?.totalAmount;

    const formatPrice = ({ amount, currencyCode }) =>
        new Intl.NumberFormat('en', {
            style: 'currency',
            currency: currencyCode,
        }).format(parseFloat(amount));

    const handleCheckout = () => {
        if (cart?.checkoutUrl) {
            window.location.href = cart.checkoutUrl;
        }
    };

    return (
        <>
            <div
                className={`cart-overlay${isOpen ? ' cart-overlay--visible' : ''}`}
                onClick={onClose}
            />
            <div className={`cart-drawer${isOpen ? ' cart-drawer--open' : ''}`}>
                <div className='cart-drawer__header'>
                    <h3>Your cart</h3>
                    <button className='cart-drawer__close' onClick={onClose} aria-label='Close cart'>
                        ×
                    </button>
                </div>

                <div className='cart-drawer__items'>
                    {lines.length === 0 ? (
                        <p className='cart-drawer__empty'>Your cart is empty.</p>
                    ) : (
                        lines.map((line) => {
                            const { merchandise, quantity, cost } = line;
                            const image = merchandise?.product?.images?.edges?.[0]?.node;
                            return (
                                <div key={line.id} className='cart-item'>
                                    {image ? (
                                        <img
                                            className='cart-item__image'
                                            src={image.url}
                                            alt={image.altText || merchandise.product.title}
                                        />
                                    ) : (
                                        <div className='cart-item__image-placeholder' />
                                    )}
                                    <div className='cart-item__details'>
                                        <p className='cart-item__name'>{merchandise?.product?.title}</p>
                                        {merchandise?.title !== 'Default Title' && (
                                            <p className='cart-item__variant'>{merchandise?.title}</p>
                                        )}
                                        <p className='cart-item__price'>
                                            {quantity > 1 && `${quantity} × `}
                                            {cost?.totalAmount ? formatPrice(cost.totalAmount) : null}
                                        </p>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>

                {lines.length > 0 && (
                    <div className='cart-drawer__footer'>
                        {totalAmount && (
                            <div className='cart-drawer__total'>
                                <span>Subtotal</span>
                                <span>{formatPrice(totalAmount)}</span>
                            </div>
                        )}
                        <button className='cart-drawer__checkout-btn' onClick={handleCheckout}>
                            Checkout
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}
